<app-dialog-header
  [title]="'Wählen Sie einen Zeitraum aus'"
  [dialogRef]="dialogRef"
  (close)="dialogRef.close()"
></app-dialog-header>

<mat-dialog-content style="display: flex; gap: 1rem; flex-direction: column;">
  <kpi4me-date-element label="Startdatum" [formControlElement]="this.dateRangeForm.controls.fromDate"></kpi4me-date-element>
  <kpi4me-date-element label="Enddatum" [formControlElement]="this.dateRangeForm.controls.toDate"></kpi4me-date-element>

  @if (dateRangeForm.hasError('invalidDateRange')) {
    <mat-error style="padding: 0.25rem">Das Startdatum muss vor dem Enddatum liegen</mat-error>
  }
</mat-dialog-content>

<div mat-dialog-actions style="margin-top:1rem;">
  <app-confirm-icon-button (customClick)="confirm()" [disabled]="dateRangeForm.invalid"></app-confirm-icon-button>
</div>
